import ExternalLogoLists from './ExternalLogoLists'

export default ExternalLogoLists
